import Vue from "vue";
import dateFormats, { DEFAULT_TIME_FORMAT_SECONDS } from "@/static/dateFormats";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const filterFormatTimeSeconds = (value: string | Date): string => {
  if (!value) return "";
  return dayjs(value, dateFormats, false).format(DEFAULT_TIME_FORMAT_SECONDS);
};

Vue.filter("formatTimeSeconds", filterFormatTimeSeconds);
